export default "__VITE_ASSET__c7f445d6__"